<div class="main-wrapper">
	<section class="header" *ngIf="renderHeader">
		<app-header></app-header>
	</section>
	<div class="main-content">
		<nav class="side-navbar" *ngIf="isAuthenticated && !iskillFullScreen">
			<app-side-navbar></app-side-navbar>
		</nav>
		<section class="content"
			[class.full-width]="!isAuthenticated"
			[class.content--iskill]="iskillFullScreen">
			<app-loader></app-loader>
			<router-outlet></router-outlet>
		</section>
	</div>
</div>
